// utils/api/build-urls.ts
const URL_EXTENSION = '/api/v3'; // or your existing value

type BuildSttSessionsUrlArgs = {
  offset?: number | string;
  limit?: number | string;
  /** Either a comma-joined string ("a,b,c") or an array of "field:op:value" */
  q?: string | string[];
  /** Optional sorting */
  sort?: string;
  direction?: 'asc' | 'desc';
};

export function buildSttSessionsUrl({
  offset,
  limit,
  q,
  sort,
  direction
}: BuildSttSessionsUrlArgs): string {
  const safeOffset = Number.isFinite(Number(offset)) ? String(offset) : '0';
  const safeLimit = Number.isFinite(Number(limit)) ? String(limit) : '25';

  const qs: string[] = [
    `offset=${encodeURIComponent(safeOffset)}`,
    `limit=${encodeURIComponent(safeLimit)}`
  ];

  if (q) {
    const list = Array.isArray(q)
      ? q
      : q
          .split(',')
          .map(s => s.trim())
          .filter(Boolean);

    for (const part of list) {
      qs.push(`q=${encodeURIComponent(part)}`);
    }
  }

  if (sort) qs.push(`sort=${encodeURIComponent(sort)}`);
  if (direction) qs.push(`direction=${encodeURIComponent(direction)}`);

  return `${URL_EXTENSION}/speech-to-text/session?${qs.join('&')}`;
}

export function appendQuery(url: string, params: Record<string, unknown>) {
  const extra = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(
      ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`
    )
    .join('&');

  if (!extra) return url;
  return url.includes('?') ? `${url}&${extra}` : `${url}?${extra}`;
}
